import {normalize} from '../../util/utils';
import {
	CLEAR_FORM_BODY_SAVE_STATE,
	SET_FORM_BODY_SAVE_STATE,
	CLEAR_FORM_BODY_SAVE_STATE_BY_BODY_ID
} from '../../actions/actiontypes';
import initialState from '../initialstate';

export default function formBodyReducer(state = initialState.formBodies, action) {
	switch (action.type) {
		case SET_FORM_BODY_SAVE_STATE: {
			let elementNames = Array.isArray(action.elementName) ? action.elementName : [action.elementName];

			const elementChangeRecord = {
				id: action.bodyId,
				elements: {
					...state.byId[action.bodyId]?.elements
				}
			};

			for (let i = 0; i < elementNames.length; i++) {
				elementChangeRecord.elements[elementNames[i]] = action.hasChanges;
			}

			return normalize([elementChangeRecord], undefined, state);
		}
		case CLEAR_FORM_BODY_SAVE_STATE: {
			// Set all bodies as without changes
			let newById = {};

			state.allIds.forEach((bodyId) => {
				newById[bodyId] = {
					...state.byId[bodyId],
					elements: []
				};
			});

			return {
				...state,
				byId: newById
			};
		}
		case CLEAR_FORM_BODY_SAVE_STATE_BY_BODY_ID: {
			return {
				...state,
				byId: {
					...state.byId,
					[action.bodyId]: {
						...state.byId[action.bodyId],
						elements: []
					}
				}
			};
		}

		default: {
			return state;
		}
	}
}
